// extracted by mini-css-extract-plugin
export var container = "Products-module--container--64ac8";
export var slider = "Products-module--slider--84abd";
export var waves = "Products-module--waves--5157e";